import {connect} from 'react-redux';
import {useState} from 'react'
import {push} from 'connected-react-router'
import {
    Header, 
    Paragraph,
    Button,
    ErrorMark
} from '../../../components/RegularComponents'
import CheckboxForm from '../../../components/CheckBoxForm'
import TopNavigationBar from '../../TopNavigationBar'
import {confirmBeforePaymentSelect} from '../../../redux/selector/confirmBeforePaymentSelector'
import { ERROR_STRING } from '../../../app/errors';
import {
    // APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
    // APPLICATION_MODE_RENEW,
    ROUTE_PATH
} from "../../../app/constants"
import { titleStringFromLicenceSubType } from '../../../redux/slice/applicationsUtils';
import { currentAgentApplicationSelector } from '../../../redux/selector/collectorApplicationSelector';
import { useSelector } from 'react-redux';
import { agencyApplicationSelector } from '../../../redux/selector/agencyApplicationSelector';

const ConfirmMraRenewalBeforePayment = (props) => {
    // const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE
    // const applicationMode = APPLICATION_MODE_RENEW
    const {dispatch, confirmBeforePayment} = props
    const [confirmCheck, setConfirmCheck] = useState(false)
    const [showValidationError,setShowValidationError] = useState(false)
    const agentApplication = useSelector(currentAgentApplicationSelector);
    const { agencyApplication } = useSelector(agencyApplicationSelector);
    let confirmSubtitle = ""
    if(agentApplication && props.location?.state?.applicationId === agentApplication.id) {
        confirmSubtitle = titleStringFromLicenceSubType(agentApplication.licencingSubType) + " renewal";
    }
    else if(agencyApplication) {
        confirmSubtitle = titleStringFromLicenceSubType(agencyApplication.licencingSubType) + " renewal";
    }

    return (
        <>
            <div className={"container"}>
                <TopNavigationBar {...props} />

                <div className="row bottomMarginMedium">
                    <div className="col-8">
                        <Header 
                            id="confirm-before-payment-header" 
                            header={confirmBeforePayment.header} />
                        
                        <h3>{confirmSubtitle}</h3>
                        <Paragraph 
                            id="confirm-before-payment-text"
                            text={confirmBeforePayment.text} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-8">
                        <CheckboxForm 
                            id="confirm-before-start-checkbox"
                            checked={confirmCheck}
                            value={confirmCheck}
                            labelText="Yes, I confirm"
                            onCheckBoxChange={(val) => {
                                setShowValidationError(false)
                                setConfirmCheck(val)
                            }}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
                        <Button
                            id="cofirm-before-payment-continue-button"
                            buttonType={"regular_primary"}
                            text={"Pay and submit application"}
                            onClick={() => {

                                if(!confirmCheck) { 
                                    setShowValidationError(true)
                                    return
                                }

                                setShowValidationError(false)

                                const nextUrl = ROUTE_PATH.MRA_APP + ROUTE_PATH.MRA_RENEWAL_PAYMENT_REVIEW
                                if(props.location?.state?.applicationId) {
                                    // console.log(">>> passing applicationId : ",props.location.state.applicationId)
                                    dispatch(push({
                                        pathname : nextUrl,
                                        state: {applicationId : props.location.state.applicationId}
                                    }))
                                } else {
                                    // console.log(">>> NOT PASSING ANY APPLICATION ID")
                                    dispatch(push(nextUrl))
                                }
                                
                            }}
                        />
                        {showValidationError && ErrorMark()}
                        {showValidationError && <div className="ns-error-message">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.CONFIRM_BEFORE_PAYMENT_CONFIRMATION_NOT_CHECKED}
                        </div>}
                    </div>
                </div>
            </div>
        </>
    )
}

export default connect(confirmBeforePaymentSelect)(ConfirmMraRenewalBeforePayment)
